<template>
  <div class="header-container">
    <span class="header-notation"></span>
    <h1>{{ title }}</h1>
  </div>
</template>

<script>
export default {
  name: "CustomHeader",
  props: ["title"]
};
</script>
<style lang="scss" scoped>
@import "../css/variable.scss";
.header-container {
  position: absolute;
  top: 20px;
  left: 0;
  display: flex;
  align-items: center;

  .header-notation {
    width: 60px;
    background-color: $main-color-cyan;
    height: 2px;
    margin-top: 10px;
    margin-right: 15px;
    position: relative;

    &::before {
      content: "";
      display: block;
      position: absolute;
      right: 10px;
      top: 0;
      width: 10px;
      height: 20px;
      border: 1px solid $main-color-cyan;
      transform: translateY(-50%);
    }
  }
  h1 {
    color: $main-color-cyan;
    font-family: Franklin Gothic Medium, Franklin Gothic, ITC Franklin Gothic,
      Arial, sans-serif;
    // font-size: 56px;
    font-size: 3.3vw;
    margin: 0;
  }
}
</style>
